import React, { lazy, Suspense } from "react";
import SEO from "@/components/SEO";
import { SEO_DATA } from "@/seo/seoData";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
// import { WhyChooseUsSection } from '@/components/home/WhyChooseUsSection';

// import { ValuePropositionSection } from '@/components/home/ValuePropositionSection';
// import { ContactSection } from '@/components/home/ContactSection';
// import { BlogPreviewSection } from '@/components/home/BlogPreviewSection';
const AboutSection = lazy(() =>
  import("@/components/home/AboutSection").then((module) => ({ default: module.AboutSection }))
);
const ServicesSection = lazy(() =>
  import("@/components/home/ServicesSection").then((module) => ({ default: module.ServicesSection }))
);
const ProcessSection = lazy(() =>
  import("@/components/home/ProcessSection").then((module) => ({ default: module.ProcessSection }))
);
const ProjectsSection = lazy(() =>
  import("@/components/home/ProjectsSection").then((module) => ({ default: module.ProjectsSection }))
);
const TrustSection = lazy(() =>
  import("@/components/home/TrustSection").then((module) => ({ default: module.TrustSection }))
);
const TestimonialsSection = lazy(() =>
  import("@/components/home/TestimonialsSection").then((module) => ({ default: module.TestimonialsSection }))
);
const FAQSection = lazy(() =>
  import("@/components/home/FAQSection").then((module) => ({ default: module.FAQSection }))
);
const CTASection = lazy(() =>
  import("@/components/home/CTASection").then((module) => ({ default: module.CTASection }))
);

export default function HomePage() {
  return (
    <Layout>
      {/* SEO Meta */}
      <SEO {...SEO_DATA.home} />

      <HeroSection />
      <Suspense fallback={null}>
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <ProjectsSection />
        <TrustSection />
        <TestimonialsSection />
        <FAQSection />

      {/* <WhyChooseUsSection /> */}
      {/* <ValuePropositionSection /> */}
      {/* <ContactSection /> */}
      {/* <BlogPreviewSection /> */}

        <CTASection />
      </Suspense>
    </Layout>
  );
}
